import React, { FC } from 'react';
import { List } from '@mui/material';
import { TEAM_MEMBER_TYPES, TTeamMemberType } from '../../models/RoleAssignmentModel';
import { toggleListItem } from '../../../../../../../shared/commonFunctions';
import { ITeamSelection } from '../../models/roleAssignmentSelectionModel';
import { SelectableListItem } from './components/SelectableListItem';
import { SelectableCollapse } from './components/SelectableCollapse';

interface ITeamTypeSectionProps {
  team: ITeamSelection;

  onIncludeFullTeam(): void;

  onChangeIncludedMemberTypes(types: TTeamMemberType[]): void;
}

export const roleTypes = ['Managers', 'Directors', 'Lieutenants'];

export const TeamSection: FC<ITeamTypeSectionProps> = ({ team, onIncludeFullTeam, onChangeIncludedMemberTypes }) => {
  const onSelectionChange = (memberType: TTeamMemberType) => {
    const updates = toggleListItem<TTeamMemberType>(team.includedTeamMemberType, memberType);
    onChangeIncludedMemberTypes(updates);
  };

  return (
    <SelectableCollapse
      open={false}
      text={team.teamName + ' [Team]'}
      checked={team.includeFullTeam}
      onChange={onIncludeFullTeam}
    >
      <List>
        <SelectableListItem
          text={team.teamName + ' Directors'}
          checked={team.includedTeamMemberType?.indexOf(TEAM_MEMBER_TYPES.Director) >= 0}
          onSelectionChange={() => onSelectionChange(TEAM_MEMBER_TYPES.Director)}
        />

        <SelectableListItem
          text={team.teamName + ' Lieutenants'}
          checked={team.includedTeamMemberType?.indexOf(TEAM_MEMBER_TYPES.Lieutenant) >= 0}
          onSelectionChange={() => onSelectionChange(TEAM_MEMBER_TYPES.Lieutenant)}
        />

        <SelectableListItem
          text={team.teamName + ' Regular Members'}
          checked={team.includedTeamMemberType?.indexOf(TEAM_MEMBER_TYPES.Member) >= 0}
          onSelectionChange={() => onSelectionChange(TEAM_MEMBER_TYPES.Member)}
        />
      </List>
    </SelectableCollapse>
  );
};
